import customAxios from "./axiosConfig";
import { encodeQueryData } from "@/utils/"

const CustomerService = {
    list: function (params) {
        var api_url = window.Urls['customer-list']();
        return customAxios.get(api_url, {params: params});
    },
    listPaginated(params){
        var api_url = window.Urls['v3:customer-list']();
        return customAxios.get(api_url, {params: params});
    },
    listNextPage(next_url){
        return customAxios.get(next_url);
    },
    getCount(params) {
        var api_url = window.Urls["customer_count"]();
        return customAxios.get(api_url, {params: params});
    },
    retrieve: function(pk, params){
        var api_url = window.Urls['customer-detail'](pk);
        return customAxios.get(api_url, { useCache: params?.useCache, params: params });
    },
    retrieveByProjectId: function(params){
        var api_url = window.Urls['customer-list']();
        return customAxios.get(api_url, { useCache: params?.useCache, params: params });
    },
    create: function (data) {
        var api_url = window.Urls['customer-list']();
        return customAxios.post(api_url, data);
    },
    update: function(pk, data) {
        var api_url = window.Urls['customer-detail'](pk);
        return customAxios.put(api_url, data);
    },
    destroy: function(pk) {
        var api_url = window.Urls['customer-detail'](pk);
        return customAxios.delete(api_url);
    },
    getContactsFileBlob(company_id, params){
        const api_url = window.Urls['company_profile_export_customers'](company_id)
        return customAxios.get(api_url, { params: params, responseType: 'blob' }).then((response) => {
          return response
        })
    }
};

export default CustomerService;